import { axiosPost } from '../utils/axios'
import apiUrl from '../configs/apiUrl'
import { getRefreshToken, removeSessionStorage, keyNameSessionStorage } from '../utils/sessionStorage'

type AuthWebResponse = {
    accessToken: string
    refreshToken: string
}

export const authWebCms = async (refreshToken: string) => {
    const { request } = axiosPost<AuthWebResponse>({
        url: apiUrl.webCmsAuth,
        params: { refreshToken },
    })
    const { data } = await request
    return data
}

export const goToWebCms = async () => {
    try {
        const response = await authWebCms(getRefreshToken() as string)
        if (response.refreshToken && response.accessToken) {
            window.location.assign(
                (process.env.REACT_APP_CMS_WEB_PORTAL as string) +
                    '?systemID=' +
                    2 +
                    '&accessToken=' +
                    response.refreshToken,
            )
            removeSessionStorage([
                keyNameSessionStorage.user,
                keyNameSessionStorage.accessToken,
                keyNameSessionStorage.refreshToken,
            ])
        } else {
            window.location.href = process.env.REACT_APP_CMS_WEB_AUTH as string
        }
    } catch (err) {
        window.location.href = process.env.REACT_APP_CMS_WEB_AUTH as string
    }
}

export const goToWebBi = async () => {
    try {
        const response = await authWebCms(getRefreshToken() as string)
        if (response.refreshToken && response.accessToken) {
            window.location.assign(
                (process.env.REACT_APP_BI_WEB_PORTAL as string) +
                    '?systemID=' +
                    5 +
                    '&accessToken=' +
                    response.refreshToken,
            )
            removeSessionStorage([
                keyNameSessionStorage.user,
                keyNameSessionStorage.accessToken,
                keyNameSessionStorage.refreshToken,
            ])
        } else {
            window.location.href = process.env.REACT_APP_CMS_WEB_AUTH as string
        }
    } catch (err) {
        window.location.href = process.env.REACT_APP_CMS_WEB_AUTH as string
    }
}
